module.exports = __webpack_public_path__ + "media/images/icons/facebook_footer-4422e4bce73330910fcc0200137df62a.svg";